import React, { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeAffiliationFilter,
  setAffiliationFilter,
  setAffiliationClusterMode,
} from 'store/filters/actions';
import { selectAffiliationFilter, selectAffiliationClusterMode } from 'store/filters/selectors';
import DropDown from '../../drop-down';
import styles from './affiliation.module.css';

const Switch = ({ isOn, handleToggle, onColor, id }) => {
  return (
    <>
      <input
        checked={isOn}
        onChange={handleToggle}
        className={styles['react-switch-checkbox']}
        id={id}
        type="checkbox"
      />
      <label
        style={{ background: isOn && onColor }}
        className={styles['react-switch-label']}
        htmlFor={id}
      >
        <span className={styles['react-switch-button']} />
      </label>
    </>
  );
};

const AfilliationFilter = ({
  local = undefined,
  setLocal = undefined,
  setClearLocal = undefined,
  useLocal = false,
}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const aff = useSelector(selectAffiliationFilter);
  const clusterMode = useSelector(selectAffiliationClusterMode);
  const [search, setSearch] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  
  const handleToggle = () => {
    setOpen(!open);
  };

  const toggleClusterMode = () => {
    dispatch(setAffiliationClusterMode(!clusterMode));
  };

  const addValue = () => {
    if (useLocal) {
      setLocal(search.trim());
    } else {
      dispatch(setAffiliationFilter(search.trim()));
    }
    setSearch('');
  };

  const onChange = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const value = e.target.value;
    setSearch(value);
  };

  const handleClear = (value) => {
    if (useLocal) {
      setClearLocal(value);
    } else {
      dispatch(removeAffiliationFilter(value));
    }
  };

  useEffect(() => {
    if (search.length > 0 && !showAdd) {
      setShowAdd(true);
    } else if (search.length < 1 && showAdd) {
      setShowAdd(false);
    }
  }, [search, setShowAdd, showAdd]);

  // Handle case where aff might be undefined or string (legacy)
  const safeAff = typeof aff === 'object' ? aff : {};
  const affiliations = useLocal ? Object.keys(local || {}) : Object.keys(safeAff);

  return (
    <div className={!open ? 'filter_by_wrapper' : 'filter_by_open_wrapper'}>
      <DropDown
        filterText={
          <span className={styles.drop_down_label}>
            <span>Affliation</span>
            {clusterMode && (
              <span className={styles.clustering_badge}>Clustering</span>
            )}
          </span>
        }
        onClick={handleToggle}
        open={open}
      />
      {open && (
        <div className={styles.open_region}>
          <div className={styles.input_region}>
            <div className={styles.input_wrapper}>
              <input
                type="text"
                className={styles.input}
                onChange={onChange}
                value={search}
                placeholder="Enter Affiliation Filter"
              />
              {showAdd && (
                <button className={styles.add} onClick={addValue}>
                  Add
                </button>
              )}
            </div>
          </div>
          {!useLocal && (
            <div className={styles.cluster_toggle_row}>
              <span className={styles.cluster_toggle_label}>Enable Clustering</span>
              <Switch
                isOn={clusterMode}
                onColor="#d84884"
                handleToggle={toggleClusterMode}
                id="affiliation-cluster-toggle"
              />
            </div>
          )}
        </div>
      )}
      {affiliations.length > 0 && (
        <div className={styles.regions_wrapper}>
          {affiliations.map((x) => (
            <div
              className={`${styles.regions_item} ${clusterMode ? styles.cluster_chip : ''}`}
              key={x}
            >
              {x}
              <AiOutlineClose onClick={() => handleClear(x)} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AfilliationFilter;
